import {del, get, patch, post} from "./request";

export const proposalApi = {};

proposalApi.add = async ({body}) => {
  try {
    const {data} = await post(`/proposal/add`, body);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

proposalApi.get = async (id) => {
  try {
    const {data} = await get(`/proposal/one/${id}`);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

proposalApi.pay = async ({paymentReference}) => {
  try {
    const {data} = await post(`/proposal/payProposal`, {paymentReference});
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

proposalApi.getPaymentReference = async ({proposalId}) => {
  const {data} = await post("/proposal/paymentReference", {proposalId});
  return data;
};

proposalApi.update = async ({id, body}) => {
  try {
    const {data} = await patch(`/proposal/update/${id}`, body);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

proposalApi.delete = async (id) => {
  try {
    const {data} = await del(`/proposal/delete/${id}`);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
